import { ValueLeftAxis } from '../../../core/components/axes/components/ValueLeftAxis.js';
import { ChartGrid } from '../../../core/components/chart-grid/ChartGridRoot.js';
import { useTimeseriesFilteredYAxis } from '../../hooks/useTimeseriesFilteredYAxis.js';
import { useTimeseriesTickAxis } from '../../hooks/useTimeseriesTickAxis.js';
import { useYScales } from '../../hooks/useYScales.js';
import { AREAS } from '../../types/timeseries-grid-area-rules.js';

export const TimeseriesValueLeftAxisArea = () => {
  const { left: axisLeftConfig } = useTimeseriesFilteredYAxis();
  const { left: scaleLeft } = useYScales();
  const tickAxis = useTimeseriesTickAxis();
  const leftTickAxis = tickAxis?.left || { ticks: [], formattedTicks: [] };

  if (!leftTickAxis.ticks.length || !scaleLeft) {
    return null;
  }

  return (
    <ChartGrid.GridArea gridArea={AREAS.leftAxis}>
      {({ availableWidth, availableHeight }) => {
        return (
          <ValueLeftAxis
            ticks={leftTickAxis.ticks}
            formattedTicks={leftTickAxis.formattedTicks}
            containerHeight={availableHeight}
            containerWidth={availableWidth}
            scale={scaleLeft.scale}
            label={axisLeftConfig?.label}
          />
        );
      }}
    </ChartGrid.GridArea>
  );
};

TimeseriesValueLeftAxisArea['displayName'] = 'TimeseriesValueLeftAxisArea';
